'use strict';

export default function($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/appconfgroups", "/appconfgroups/list");
  $stateProvider
    .state('appconfgroups', {
      url: '/appconfgroups',
      template: require('./appconfgroups.html'),
      authenticate: true
    })
    .state('appconfgroups.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'AppConfGroupsListController',
      controllerAs: 'appconfgroupsListCtrl'
    })
    .state('appconfgroups.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'AppConfGroupsEditController',
      controllerAs: 'appconfgroupsEditCtrl'
    })
    .state('appconfgroups.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'AppConfGroupsAddController',
      controllerAs: 'appconfgroupsAddCtrl'
    })
    .state('appconfgroups.show', {
      url: '/show/:id',
      template: require('./show/show.html'),
      controller: 'AppConfGroupsShowController',
      controllerAs: 'appconfgroupsShowCtrl'
    })
    .state('appconfgroups.addmodel', {
      url: '/:id/addmodel',
      template: require('./addmodel/addmodel.html'),
      controller: 'AppConfGroupsAddModelController',
      controllerAs: 'appconfgroupsAddModelCtrl'
    })
    // .state('betagroups.import', {
    //   url: '/:id/import',
    //   template: require('./import/import.html'),
    //   controller: 'BetaGroupsImportController',
    //   controllerAs: 'betagroupsImportCtrl'
    // });
}



// WEBPACK FOOTER //
// ./client/app/appconfgroups/appconfgroups.routes.js